<template>
  <div class="content-left">
    <video autoplay loop muted playsinline :poster="getFeUrl(`${prefix}/login/output.jpg`, ts)">
      <source v-for="video in videoSources" :key="video" :src="video" />
    </video>
  </div>
</template>

<script setup lang="ts">
import dayjs from 'dayjs';
import { isChinese } from '~/utils/area';
import { getFeUrl } from '~/utils/url';

const ts = dayjs().format('YYYYMMDD');

const prefix = isChinese() ? '/youyan' : '/rendora';

const videoSources = [
  getFeUrl(`${prefix}/login/login.webm`, ts),
  getFeUrl(`${prefix}/login/login.mp4`, ts),
];
</script>

<style lang="scss" scoped>
.content-left {
  height: 100vh;
  aspect-ratio: 775 / 968;
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
